import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ChangeOfVariable = () => (
  <QPhototModuleSubtopic
    title="Change of variable"
    videos={[
      "https://www.youtube.com/embed/ntc-f4yQlsk"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_48.jpeg"
        },
        {
            image:"/cal_49.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default ChangeOfVariable;
